import { teleTools, tools } from "./data";

export type MoreToolPlatform = "tg";

export type MoreToolIcon = "tgsend" | "video" | "translate" | "shield";

export type MoreTool = {
  platform: MoreToolPlatform;
  icon: MoreToolIcon;
  cat: string;
  name: string;
  desc: string;
  feats: string[];
  installUrl: string;
  tutorialUrl: string;
};

export type PipelineStep = {
  id: string;
  tag: string;
  step: number;
  name: string;
  desc: string;
  kind: "send" | "video" | "translate" | "shield";
};

function toolById(id: (typeof tools)[number]["id"]) {
  const t = tools.find((x) => x.id === id);
  if (!t) throw new Error(`Unknown tool id: ${id}`);
  return t;
}

const tgb = toolById("tgb");
const tgv = toolById("tgv");
const tgt = toolById("tgt");
const [tgPrivacy] = teleTools;

export const moreToolsPipeline: PipelineStep[] = [
  {
    id: "pb1",
    tag: "Step 1",
    step: 1,
    name: "Telegram Bulk Sender",
    desc: "Blast personalised bulk messages on Telegram Web at scale.",
    kind: "send",
  },
  {
    id: "pb2",
    tag: "Step 2",
    step: 2,
    name: "Telegram Video Downloader",
    desc: "Save videos, images, and private media in one click.",
    kind: "video",
  },
  {
    id: "pb3",
    tag: "Step 3",
    step: 3,
    name: "Telegram Web Translator",
    desc: "Translate messages into any language as you chat.",
    kind: "translate",
  },
  {
    id: "pb4",
    tag: "Step 4",
    step: 4,
    name: "Telegram Privacy Extension",
    desc: "Blur chats, names, and media to protect your screen.",
    kind: "shield",
  },
];

export const moreToolsCatalog: MoreTool[] = [
  {
    platform: "tg",
    icon: "tgsend",
    cat: "Marketing",
    name: "Telegram Sender Pro",
    desc: "Mass sender for unlimited texts and automated outreach.",
    feats: ["Import numbers via Excel", "Automated bulk message blasts"],
    installUrl: tgb.extensionUrl,
    tutorialUrl: "https://youtu.be/_N7-iFk5cRk?si=M8lca7MqSSgQ6jP0",
  },
  {
    platform: "tg",
    icon: "video",
    cat: "Media",
    name: "Telegram Video Downloader",
    desc: "Download videos, images, and private media from Telegram Web.",
    feats: ["One-click real-time saves", "Batch download multiple files"],
    installUrl: tgv.extensionUrl,
    tutorialUrl: "https://youtu.be/jDFMOBT8n2k?si=8E7rlp7xI7inA6uD",
  },
  {
    platform: "tg",
    icon: "translate",
    cat: "Global",
    name: "Telegram Web Translator",
    desc: "One-click or auto-translation for seamless chats.",
    feats: ["Accurate language auto-detect", "Reply in any language"],
    installUrl: tgt.extensionUrl,
    tutorialUrl: "https://youtu.be/Mid0uRvln0s?si=EQDXlFf8s1-cCvtg",
  },
  {
    platform: "tg",
    icon: "shield",
    cat: "Privacy",
    name: "Telegram Privacy Extension",
    desc: "Blur chats, names, and media to protect your screen.",
    feats: ["Blur everything in one click", "Choose exactly what to hide"],
    installUrl: tgPrivacy.url,
    tutorialUrl: "https://www.youtube.com/watch?v=OXeTc3IT_RU",
  },
];

export const moreToolsTg = moreToolsCatalog;
